import React, { Component } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import "./index.scss";
import "./kido-theme.css";
import "./kido-ui.css";
import "./components/1688-taobao-orders/orders-kido.css";
import "./components/expense-history/kido-cash.css";
import "./components/products/physical/products-kido.css";
import App from "./components/app";
import KidoLoader from "./components/common/KidoLoader";
import { ScrollContext } from "react-router-scroll-4";
import { Provider } from "react-redux";

// Components
import store from "./store";
import Dashboard from "./components/dashboard";

// Products physical
import AllProducts from "./components/products/physical/allProducts";
import AllProductsByCategory from "./components/products/physical/allProductsByCategory";
import AllProductsByBrand from "./components/products/physical/allProductsByBrand";
import AllProductsByCampaign from "./components/products/physical/allProductsByCampaign.js";
import AllCoupons from "./components/products/physical/allCoupons";
import Sub_category from "./components/products/physical/sub-category";
import Product_list from "./components/products/physical/product-list";
import Add_product from "./components/products/physical/add-product";
import Edit_product from "./components/products/physical/edit-product";
import Add_Aliexpress_product from "./components/products/physical/add-aliexpress-product";
import Product_detail from "./components/products/physical/product-detail";
import Brands from "./components/products/physical/brands";
import Categories from "./components/products/physical/categories";
import HomeCategories from "./components/products/physical/homeCategories";
import Banners from "./components/products/physical/banner";
import ShopByConcern from "./components/products/physical/shopByConcern";
import Attributes from "./components/products/physical/attributes";
import AttributeTerms from "./components/products/physical/attributeTerms";

//Sales
import Orders from "./components/sales/orders";
import PendingOrders from "./components/sales/pendingOrders";
import PaymentApproved from "./components/sales/paymentApproved";
import Ordered from "./components/sales/ordered";
import ChinaWarehouse from "./components/sales/chinaWarehouse";
import InShipment from "./components/sales/inShipment";
import InStock from "./components/sales/inStock";
import Delivered from "./components/sales/delivered";
import UpdateOrder from "./components/sales/updateOrder";

//Coupons
import UnverifiedPayments from "./components/payments/unVerifiedPayments";
import VerifiedPayments from "./components/payments/verifiedPayments";
import Create_coupons from "./components/payments/create-coupons";

//Pages
import ProductToOrder from "./components/pages/product-to-order";
import Create_page from "./components/pages/create-page";
import Media from "./components/media/media";
import List_menu from "./components/menus/list-menu";
import Create_menu from "./components/menus/create-menu";
import List_user from "./components/users/list-user";
import Create_user from "./components/users/create-user";
import ListSuppliers from "./components/suppliers/list-suppliers";
import DetailUser from "./components/users/detail-user";
import Currency from "./components/localization/currency";
import Taxes from "./components/localization/taxes";
import Add_Product_Tax from "./components/localization/add_product_tax";
import Update_Product_Tax from "./components/localization/update-product-tax";
import Profile from "./components/settings/profile";
import Reports from "./components/reports/report";

import Datatable from "./components/common/datatable";
import Login from "./components/auth/login";
import RegisterAdmin from "./components/auth/registerAdmin";
import { auth, firestore } from "./firebase/firebase.utils";
import SearchedOrder from "./components/searched-order/searched-order";
import PaymentRequest from "./components/payment-request/paymentRequest";
// Product Reqeust
import New from "./components/product-requests/new";
import NewShipmentRequest from "./components/shipment-request/new";
import OrdersApi from "./components/1688-taobao-orders/new";
import SteadfastPayments from "./components/steadfast/payments";
import SteadfastPaymentDetail from "./components/steadfast/payment-detail";
import BuyAndShipForMeInvoice from "./components/1688-taobao-orders/invoice-by-order.js";
import PreOrdersNew from "./components/pre-orders/new";
import PartialPayment from "./components/pre-orders/partialPayments";
import PaymentLink from "./components/pre-orders/paymentLink";
import ConsultancySourcingMonth from "./components/business-consultancy/sourcing/invoice/month";
import ConsultancySourcingMonthlyInvoice from "./components/business-consultancy/sourcing/invoice/monthly-invoices";
import ConsultancySourcingProductDetails from "./components/business-consultancy/sourcing/invoice/productDetails";
import ConsultancySourcingAgents from "./components/business-consultancy/sourcing/sourcing-agents/agents";
import ConsultancySourcingAgentMonths from "./components/business-consultancy/sourcing/sourcing-agents/month";
import ConsultancySourcingAgentMonthlyInvoices from "./components/business-consultancy/sourcing/sourcing-agents/monthly-invoices";
import PaymentRequestOrder from "./components/payment-request/paymentRequestOrder";
import RefundRequestsPage from "./components/refund-requests";
import Reviews from "./components/products/physical/reviews";
import Campaigns from "./components/products/physical/allCampaigns";
import Announcements from "./components/products/physical/allAnnouncements";
import Invoice from "./components/1688-taobao-orders/invoice";
import MonthlyExpense from "./components/expense-history/monthly-expense/monthlyexpense";
import DailyExpense from "./components/expense/daily-expense";
import SalaryMonth from "./components/expense-history/salary/monthlyexpense";
import Salaries from "./components/expense-history/salary/monthlyexpenseByMonth";
import Refunds from "./components/expense-history/refund/monthlyexpenseByMonth";
import RefundsMonth from "./components/expense-history/refund/monthlyexpense";
import CommisionMonth from "./components/expense-history/agent-commision/monthlyexpense";
import Commisions from "./components/expense-history/agent-commision/monthlyexpenseByMonth";
import OrderMonth from "./components/expense-history/order/monthlyexpense";
import Order from "./components/expense-history/order/monthlyexpenseByMonth";
import BoostingMonth from "./components/expense-history/boostings/monthlyexpense";
import Boostings from "./components/expense-history/boostings/monthlyexpenseByMonth";
import ShippingMonth from "./components/expense-history/shippings/monthlyexpense";
import Shippings from "./components/expense-history/shippings/monthlyexpenseByMonth";
import LotTransportMonth from "./components/expense-history/lot-transport/monthlyexpense";
import OfficeCostsLotTransport from "./components/expense-history/lot-transport/monthlyexpenseByMonth";
import Courier from "./components/expense-history/courier/monthlyexpense";
import CourierMonth from "./components/expense-history/courier/monthlyexpenseByMonth";
import Loans from "./components/expense-history/loan/monthlyexpense";
import Customers from "./components/expense-history/loan/customer";
import Customers2 from "./components/expense-history/customer-due/customer.js";
import OnlyInvoiceToPrint2 from "./components/expense-history/customer-due/invoice-by-order.js";
import SingleCustomer from "./components/expense-history/loan/singleCustomer";
import Office from "./components/expense-history/office/office";
import OfficeMonth from "./components/expense-history/office/monthlyexpense";
import OfficeExpenses from "./components/expense-history/office/monthlyexpenseByMonth";
import CustomersInstallments from "./components/expense-history/monthly-installment/customer";
import SingleCustomerInstallments from "./components/expense-history/monthly-installment/singleCustomer";
import ApproveExpense from "./components/expense-history/approve-expense/approveExpense";
import ExpenseByDay from "./components/expense-history/approve-expense/daily-expense";
import Cnf from "./components/expense-history/cnf/cnf";
import CnfExpenses from "./components/expense-history/cnf/monthlyexpenseByMonth";
import CnfMonth from "./components/expense-history/cnf/monthlyexpense";

import OfficeCostMonth from "./components/expense-history/daily-cost/monthlyexpense";
import OfficeCosts from "./components/expense-history/daily-cost/monthlyexpenseByMonth";
import Employee from "./components/expense-history/employee/employee";
import EmployeeMonth from "./components/expense-history/employee/monthlyexpense";
import EmployeeExpenses from "./components/expense-history/employee/monthlyexpenseByMonth";
import Fund from "./components/expense-history/fund/fund.js";
import CashSummary from "./components/expense-history/cash-summary/monthlyexpense";
import CashSummaryByMonth from "./components/expense-history/cash-summary/monthlyexpenseByMonth";
import CashSummaryByDate from "./components/expense-history/cash-summary/daily-expense";
import MonthlyExpenseByMonth from "./components/expense-history/monthly-expense/monthlyexpenseByMonth";
import LoanMonthly from "./components/expense-history/loan/monthlyexpenseByMonth";
import Screenshots from "./components/products/physical/screenshots.js";
import allProducts from "./components/products/physical/allProducts";
import SellsReport from "./components/products/physical/sellsReport";
import RestockDashboard from "./components/products/physical/restockDashboard";
import ProfitReport from "./components/reports/profit-report/profitReport";
import InvestMonth from "./components/expense-history/invest/monthlyexpense";
import Invests from "./components/expense-history/invest/monthlyexpenseByMonth";
import List_admin from "./components/admins/list-admin";
class Root extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentAdmin: null,
      loading: true,
    };
    this.unsubscribeAuth = null;
  }

  componentDidMount() {
    this.unsubscribeAuth = auth.onAuthStateChanged(async (userAuth) => {
      if (userAuth) {
        const adminRef = firestore.doc(`admins/${userAuth.uid}`);
        const snap = await adminRef.get();
        if (snap.exists) {
          this.setState({ currentAdmin: { id: snap.id, ...snap.data() }, loading: false });
        } else {
          this.setState({ currentAdmin: null, loading: false });
        }
      } else {
        this.setState({ currentAdmin: null, loading: false });
      }
    });
  }

  componentWillUnmount() {
    if (this.unsubscribeAuth) this.unsubscribeAuth();
  }

  setCurrentAdmin = (adminObj) => {
    this.setState({ currentAdmin: adminObj });
  };

  render() {
    const { currentAdmin, loading } = this.state;

    if (loading) {
      return <KidoLoader />;
    }

    return (
      <Provider store={store}>
        <BrowserRouter basename={"/"}>
          <ScrollContext>
            <Switch>
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/`}
                component={(routerProps) =>
                  currentAdmin ? (
                    <Redirect to={`${process.env.PUBLIC_URL}/dashboard`} />
                  ) : (
                    <Login
                      {...routerProps}
                      setCurrentAdmin={this.setCurrentAdmin}
                      currentAdmin={currentAdmin}
                    />
                  )
                }
              />
              {/* <Route exact path={`${process.env.PUBLIC_URL}/auth/login`} component={(routerProps) => currentAdmin ? <Login {...routerProps} /> : <Redirect to="/" />} /> */}

              <App>
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/dashboard`}
                  component={(routerProps) => currentAdmin ? <Dashboard {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/refund-requests`}
                  component={(routerProps) => currentAdmin ? <RefundRequestsPage {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/searched-order/:orderId`}
                  component={(routerProps) => currentAdmin ? <SearchedOrder {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/all-products`}
                  component={(routerProps) => currentAdmin ? <AllProducts {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/coupons/physical/all-coupons`}
                  component={(routerProps) => currentAdmin ? <AllCoupons {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/brands`}
                  component={(routerProps) => currentAdmin ? <Brands {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/categories`}
                  component={(routerProps) => currentAdmin ? <Categories {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/categories/:id`}
                  component={(routerProps) => currentAdmin ? <AllProductsByCategory {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/brands/:id`}
                  component={(routerProps) => currentAdmin ? <AllProductsByBrand {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/campaigns`}
                  component={(routerProps) => currentAdmin ? <Campaigns {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/campaigns/:id`}
                  component={(routerProps) => currentAdmin ? <AllProductsByCampaign {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/announcements`}
                  component={(routerProps) => currentAdmin ? <Announcements {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/categories-2/homescreen`}
                  component={(routerProps) => currentAdmin ? <HomeCategories {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/banners`}
                  component={(routerProps) => currentAdmin ? <Banners {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/shop-by-concern`}
                  component={(routerProps) => currentAdmin ? <ShopByConcern {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/attributes`}
                  component={(routerProps) => currentAdmin ? <Attributes {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/reviews`}
                  component={(routerProps) => currentAdmin ? <Reviews {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/reviews-screenshot`}
                  component={(routerProps) => currentAdmin ? <Screenshots {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/attributes/:id`}
                  component={(routerProps) => currentAdmin ? <AttributeTerms {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/sub-category`}
                  component={(routerProps) =>
                    currentAdmin ? <Sub_category {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/product-list`}
                  component={(routerProps) =>
                    currentAdmin ? <Product_list {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/product-detail`}
                  component={(routerProps) =>
                    currentAdmin ? <Product_detail {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/add-product`}
                  component={(routerProps) => <Add_product {...routerProps} />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/add-product/:id`}
                  component={(routerProps) => currentAdmin ? <Edit_product {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/draft-products/:id`}
                  component={(routerProps) => currentAdmin ? <Edit_product {...routerProps} isDraft={true} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/add-aliexpress-product`}
                  component={(routerProps) => <Add_Aliexpress_product {...routerProps} />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/all-products/sells-report/:id`}
                  component={(routerProps) => currentAdmin ? <SellsReport {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/restock-dashboard`}
                  component={(routerProps) => currentAdmin ? <RestockDashboard {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/reports/profit`}
                  component={(routerProps) => currentAdmin ? <ProfitReport {...routerProps} /> : <Redirect to="/" />}
                />
                {/* <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/products/physical/add-product/:id`}
                  component={(props) => currentAdmin ? <Update_product {...props} /> : <Redirect to="/" />}
                /> */}

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/orders`}
                  component={(routerProps) => currentAdmin ? <Orders {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/orders/update-status/:orderId`}
                  component={(props) => currentAdmin ? <UpdateOrder {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/order_pending`}
                  component={(props) => currentAdmin ? <PendingOrders {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/payment_approved`}
                  component={(props) => currentAdmin ? <PaymentApproved {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/ordered`}
                  component={(props) => currentAdmin ? <Ordered {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/china_warehouse`}
                  component={(props) => currentAdmin ? <ChinaWarehouse {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/in-shipping`}
                  component={(props) => currentAdmin ? <InShipment {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/in_stock`}
                  component={(props) => currentAdmin ? <InStock {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/sales/delivered`}
                  component={(props) => currentAdmin ? <Delivered {...props} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/payments/unVerified`}
                  component={(routerProps) => currentAdmin ? <UnverifiedPayments {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/payments/verified`}
                  component={(routerProps) => currentAdmin ? <VerifiedPayments {...routerProps} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/pages/product-to-order`}
                  component={(routerProps) => currentAdmin ? <ProductToOrder {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/pages/create-page`}
                  component={(routerProps) =>
                    currentAdmin ? <Create_page {...routerProps} /> : <Redirect to="/" />
                  }
                />

                {/* <Route exact epath={`${process.env.PUBLIC_URL}/media`} component={(routerProps) => currentAdmin ? <Media {...routerProps} /> : <Redirect to="/" />} /> */}

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/menus/list-menu`}
                  component={(routerProps) =>
                    currentAdmin ? <List_menu {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/menus/create-menu`}
                  component={(routerProps) =>
                    currentAdmin ? <Create_menu {...routerProps} /> : <Redirect to="/" />
                  }
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/users/list-user`}
                  component={(routerProps) => currentAdmin ? <List_user {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/users/list-user/:userId`}
                  component={(routerProps) => currentAdmin ? <DetailUser {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/users/create-user`}
                  component={(routerProps) =>
                    currentAdmin ? <Create_user {...routerProps} /> : <Redirect to="/" />
                  }
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/suppliers/list_suppliers`}
                  component={(routerProps) => <ListSuppliers {...routerProps} />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/localization/currency-rates`}
                  component={(routerProps) => currentAdmin ? <Currency {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/localization/shipping-charges`}
                  component={(routerProps) => currentAdmin ? <Taxes {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/localization/shipping-charge/add-product`}
                  component={(routerProps) => currentAdmin ? <Add_Product_Tax {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/localization/shipping-charges/add-product/:id`}
                  component={(routerProps) => currentAdmin ? <Update_Product_Tax {...routerProps} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/settings/profile`}
                  component={(routerProps) => currentAdmin ? <Profile {...routerProps} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/product-request/:bookingStatus`}
                  component={(routerProps) => currentAdmin ? <New {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/shipment-request/:bookingStatus`}
                  component={(routerProps) => currentAdmin ? <NewShipmentRequest {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/orders/:orderStatus`}
                  component={(routerProps) => currentAdmin ? <OrdersApi {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/steadfast/payments`}
                  component={(routerProps) => currentAdmin ? <SteadfastPayments {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/steadfast/payment-detail/:id`}
                  component={(props) => currentAdmin ? <SteadfastPaymentDetail {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/payment-request/pending`}
                  component={(routerProps) => currentAdmin ? <PaymentRequest {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/payment-request-order/pending`}
                  component={(routerProps) => currentAdmin ? <PaymentRequestOrder {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/invoice/:orderId`}
                  component={(routerProps) => currentAdmin ? <Invoice {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/pages/dashboard/buy-and-ship-for/invoice/:bookingId`}
                  component={(routerProps) => currentAdmin ? <BuyAndShipForMeInvoice {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/pre-orders/:orderStatus`}
                  component={(routerProps) =>
                    currentAdmin ? <PreOrdersNew {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/business-consultancy/sourcing-invoice-months`}
                  component={(routerProps) =>
                    currentAdmin ? <ConsultancySourcingMonth {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/business-consultancy/sourcing/invoice/:month`}
                  component={(routerProps) =>
                    currentAdmin ? <ConsultancySourcingMonthlyInvoice {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/business-consultancy/sourcing/:invoiceId`}
                  component={(routerProps) =>
                    currentAdmin ? <ConsultancySourcingProductDetails {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/business-consultancy/sourcing-invoice-agents`}
                  component={(routerProps) =>
                    currentAdmin ? <ConsultancySourcingAgents {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/business-consultancy/sourcing/agents/:agent`}
                  component={(routerProps) =>
                    currentAdmin ? <ConsultancySourcingAgentMonths {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/business-consultancy/sourcing/agents/:agent/:month`}
                  component={(routerProps) =>
                    currentAdmin ? <ConsultancySourcingAgentMonthlyInvoices {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/1688-orders/partial-payment`}
                  component={(routerProps) =>
                    currentAdmin ? <PartialPayment {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/1688-orders/payment-link`}
                  component={(routerProps) =>
                    currentAdmin ? <PaymentLink {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/data-table`}
                  component={(routerProps) =>
                    currentAdmin ? <Datatable {...routerProps} /> : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/admins/list-admin`}
                  component={(routerProps) => currentAdmin ? <List_admin {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/admins/register`}
                  component={(routerProps) =>
                    currentAdmin && currentAdmin.status === "Admin"
                      ? <RegisterAdmin {...routerProps} />
                      : <Redirect to="/" />
                  }
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/expense-history`}
                  render={(props) => currentAdmin ? <MonthlyExpense {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/expense-history/:month`}
                  render={(props) => currentAdmin ? <MonthlyExpenseByMonth {...props} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/salary`}
                  render={(props) => currentAdmin ? <SalaryMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/salary/:month`}
                  render={(props) => currentAdmin ? <Salaries {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/daily-expense`}
                  component={(routerProps) => currentAdmin ? <DailyExpense {...routerProps} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/refunds`}
                  render={(props) => currentAdmin ? <RefundsMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/refunds/:month`}
                  render={(props) => currentAdmin ? <Refunds {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/buy-products`}
                  render={(props) => currentAdmin ? <CommisionMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/buy-products/:month`}
                  render={(props) => currentAdmin ? <Commisions {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/order`}
                  render={(props) => currentAdmin ? <OrderMonth {...props} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/order/:month`}
                  render={(props) => currentAdmin ? <Order {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/boosting`}
                  render={(props) => currentAdmin ? <BoostingMonth {...props} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/boosting/:month`}
                  render={(props) => currentAdmin ? <Boostings {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/shipping`}
                  render={(props) => currentAdmin ? <ShippingMonth {...props} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/shipping/:month`}
                  render={(props) => currentAdmin ? <Shippings {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/lot-transport`}
                  render={(props) => currentAdmin ? <LotTransportMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/lot-transport/:month`}
                  render={(props) => currentAdmin ? <OfficeCostsLotTransport {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/courier`}
                  render={(props) => currentAdmin ? <Courier {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/courier/:month`}
                  render={(props) => currentAdmin ? <CourierMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/loans`}
                  render={(props) => currentAdmin ? <Loans {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/loans/:month`}
                  render={(props) => currentAdmin ? <LoanMonthly {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/loans-by-customers`}
                  render={(props) => currentAdmin ? <Customers {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/loans-by-customers2/pdf`}
                  render={(props) => currentAdmin ? <OnlyInvoiceToPrint2 {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/loans-by-customers2`}
                  render={(props) => currentAdmin ? <Customers2 {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/loans-by-customers/:customer`}
                  render={(props) => currentAdmin ? <SingleCustomer {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/office`}
                  render={(props) => currentAdmin ? <Office {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/office/:name`}
                  render={(props) => currentAdmin ? <OfficeMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/singleOffice/office/:month`}
                  render={(props) => currentAdmin ? <OfficeExpenses {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/monthly-installment`}
                  component={(routerProps) => currentAdmin ? <CustomersInstallments {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/invest`}
                  render={(props) => currentAdmin ? <InvestMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/invest/:month`}
                  render={(props) => currentAdmin ? <Invests {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/installments-by-customers/:customer`}
                  component={(routerProps) => currentAdmin ? <SingleCustomerInstallments {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/approve-expense`}
                  render={(props) => currentAdmin ? <ApproveExpense {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/approve-expense/:date`}
                  render={(props) => currentAdmin ? <ExpenseByDay {...props} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/cnf`}
                  component={(routerProps) => currentAdmin ? <Cnf {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/cnf/:name`}
                  component={(routerProps) => currentAdmin ? <CnfExpenses {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expenses/cnf/:month`}
                  component={(routerProps) => currentAdmin ? <CnfMonth {...routerProps} /> : <Redirect to="/" />}
                />

                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/daily-cost`}
                  render={(props) => currentAdmin ? <OfficeCostMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/daily-cost/:month`}
                  render={(props) => currentAdmin ? <OfficeCosts {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/employee`}
                  render={(props) => currentAdmin ? <Employee {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/employee/:name`}
                  render={(props) => currentAdmin ? <EmployeeMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/employees/:month`}
                  render={(props) => currentAdmin ? <EmployeeExpenses {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/expense/fund`}
                  component={(routerProps) => currentAdmin ? <Fund {...routerProps} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/cash-summary`}
                  render={(props) => currentAdmin ? <CashSummary {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/cash-summary/:month`}
                  render={(props) => currentAdmin ? <CashSummaryByMonth {...props} /> : <Redirect to="/" />}
                />
                <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/cash-summary-by-day/:date`}
                  render={(props) => currentAdmin ? <CashSummaryByDate {...props} /> : <Redirect to="/" />}
                />
              </App>
            </Switch>
          </ScrollContext>
        </BrowserRouter>
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById("root"));
